/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import {
  NbDatepickerModule,
  NbDialogModule,
  NbIconModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { AgGridModule } from 'ag-grid-angular';
import { initializeApp,provideFirebaseApp } from '@angular/fire/app';
import { environment } from '../environments/environment';
import { provideAuth,getAuth } from '@angular/fire/auth';
import { provideFirestore,getFirestore } from '@angular/fire/firestore';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { StatusRendererComponent } from './shared/components/ag-grid/status-renderer/status-renderer.component';
import { UserRendererComponent } from './shared/components/ag-grid/user-renderer/user-renderer.component';
import { ProviderRendererComponent } from './shared/components/ag-grid/provider-renderer/provider-renderer.component';
import { VotesRendererComponent } from './shared/components/ag-grid/votes-renderer/votes-renderer.component';
import { NbAuthModule, NbPasswordAuthStrategy } from '@nebular/auth';
import { NbFirebaseAuthModule, NbFirebasePasswordStrategy } from '@nebular/firebase-auth';
import { AuthGuard } from './shared/guards/auth-guard.service';

@NgModule({
  declarations: [AppComponent, StatusRendererComponent, UserRendererComponent, ProviderRendererComponent, VotesRendererComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    AgGridModule,
    NbIconModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    NbFirebaseAuthModule,
    NbAuthModule.forRoot({
      strategies: [
        NbFirebasePasswordStrategy.setup({
          name: 'password',
          // login: {
          //   redirect: {
          //     success: '/',
          //     failure: null,
          //   },
          //   defaultErrors: ['Login/Email combination is not correct, please try again.'],
          //   defaultMessages: ['You have been successfully logged in.'],
          // },
        }),
        // NbPasswordAuthStrategy.setup({
        //   name: 'email',
        // }),
      ],
      forms: {
        login: {
          strategy: 'password',
          rememberMe: true,
          socialLinks: [],
        },
        // register: {
        //   strategy: 'password',
        //   terms: true,
        //   socialLinks: [],
        // },
        logout: {
          strategy: 'password',
        },
        requestPassword: {
          strategy: 'password',
          socialLinks: [],
        },
        resetPassword: {
          strategy: 'password',
          socialLinks: [],
        },
        // validation: {
        //   password: {
        //     required: true,
        //     minLength: 6,
        //     maxLength: 50,
        //   },
        //   email: {
        //     required: true,
        //   },
        //   fullName: {
        //     required: false,
        //     minLength: 4,
        //     maxLength: 50,
        //   },
        // },
      },
     }),
  ],
  providers: [
    AuthGuard
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
